export default __webpack_public_path__ + "static/media/Cost-reduction-icon.7255a639.png";